import { makeDialog } from '@cast/design-system';
import { Organization } from '@cast/types';

import {
  UpdateOrganizationDialogContent,
  UpdateOrganizationDialogProps,
} from './UpdateOrganizationDialog';

const useUpdateOrganizationDialogBase =
  makeDialog<UpdateOrganizationDialogProps>(UpdateOrganizationDialogContent, {
    closeOnOverlayClick: true,
  });

export const useUpdateOrganizationDialog = () => {
  const { openDialog } = useUpdateOrganizationDialogBase();

  const openUpdateOrganizationDialog = (organization: Organization) => {
    openDialog({ organization });
  };

  return { openUpdateOrganizationDialog };
};
